var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zv-components"},[_c('div',{ref:"gauge",staticClass:"gauge"}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }